<div class="skeleton-content">
  <aside class="filter-sidebar">
    <inexp-skeleton width="50%" height="1.5rem" />
    @for (group of filterGroups; track $index) {
      <div class="filter-group">
        <inexp-skeleton width="40%" height="1rem" />
        @for (item of filterItems; track $index) {
          <inexp-skeleton width="80%" height="0.875rem" />
        }
      </div>
    }
  </aside>

  <main class="results-area">
    <inexp-skeleton width="12rem" height="1.5rem" />
    <div class="result-cards">
      @for (card of resultCards; track $index) {
        <div class="result-card">
          <inexp-skeleton width="65%" height="1.5rem" />
          @for (line of cardLines; track $index) {
            <inexp-skeleton [width]="$last ? '85%' : '100%'" height="0.875rem" />
          }
        </div>
      }
    </div>
  </main>
</div>
